import request from '@/utils/request';

/* eslint-disable */
const actions = {
  async addColor({ dispatch, commit }, color) {
    try {
      const { data } = await request.post('colors', color);

      if (data.error) {
        throw Error('Server-side validation failed');
      }
    } catch (err) {
      throw err;
    }
  },
};

export default actions;
